var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerfulReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.45 198.9C154.375 198.9 198.9 154.375 198.9 99.45C198.9 44.5253 154.375 0 99.45 0C44.5253 0 0 44.5253 0 99.45C0 154.375 44.5253 198.9 99.45 198.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42 36.6201H48.48V162.27H150.42V36.6201Z",
    fill: "#A6A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.02 80H58.88V83.16H140.02V80Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54 69.5703H58.88V72.7203H95.54V69.5703Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54 59.1401H58.88V62.2901H95.54V59.1401Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54 48.71H58.88V51.86H95.54V48.71Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.02 90.4302H58.88V93.5802H140.02V90.4302Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.02 100.86H58.88V104.01H140.02V100.86Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.02 111.29H58.88V114.44H140.02V111.29Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52 59.7201C134.11 51.8901 127.61 45.6401 119.68 45.6401C119.51 45.6401 119.34 45.6401 119.17 45.6401V50.6901C119.34 50.6901 119.51 50.6801 119.68 50.6801C124.83 50.6801 129.06 54.6601 129.46 59.7101H128.07L131.81 63.8701L135.66 59.7101H134.52V59.7201Z",
    fill: "#E8564D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 48.4202L118.4 44.2002V45.7002C110.88 46.3402 104.94 52.6202 104.83 60.2802H109.87C109.98 55.3902 113.68 51.3802 118.42 50.7702V52.5602L123 48.4202Z",
    fill: "#2997C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53 60.9002L131.8 63.8802L129.48 61.2702C129.31 64.9602 127.18 67.3202 124.15 69.2302C122.81 69.9302 121.29 70.3202 119.68 70.3202C114.37 70.3202 110.03 66.0802 109.87 60.8002H111.64L107.5 56.2202L103.28 60.8202H104.82C104.99 68.8602 111.59 75.3602 119.67 75.3602C122.85 75.3602 125.8 74.3502 128.22 72.6402C128.26 72.6102 128.31 72.5802 128.35 72.5502C128.4 72.5202 128.44 72.4802 128.49 72.4502C132.02 69.8602 134.37 65.4702 134.52 60.9102L134.53 60.9002Z",
    fill: "#001B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.97 129.57H85.65V153.56H91.97V129.57Z",
    fill: "#E8564D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7 138.08H93.38V153.96H99.7V138.08Z",
    fill: "#2997C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44 132.91H101.12V153.96H107.44V132.91Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.17 146.02H108.85V153.96H115.17V146.02Z",
    fill: "#8E60A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71 152.78V117.83H80.79V154.69H118.6V152.78H82.71Z",
    fill: "#001B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.14 127.19L91.49 123.79L96.88 133.94L104.26 126.61L112.01 136.83L117.81 130.28",
    stroke: "#001B46",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6101 127.96C85.1501 128.3 84.5001 128.2 84.1701 127.74C83.8301 127.28 83.9301 126.64 84.3901 126.3C84.8501 125.96 85.4901 126.06 85.8301 126.52C86.1701 126.98 86.0601 127.62 85.6101 127.96Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78 127.52C104.32 127.86 103.68 127.76 103.34 127.3C103 126.84 103.11 126.2 103.56 125.86C104.02 125.52 104.67 125.62 105 126.08C105.34 126.54 105.24 127.19 104.78 127.52Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6201 134.81C97.1601 135.15 96.5201 135.05 96.1801 134.59C95.8401 134.13 95.9401 133.48 96.4001 133.15C96.8601 132.81 97.5001 132.91 97.8401 133.37C98.1801 133.83 98.0801 134.48 97.6201 134.81Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9801 124.74C91.5201 125.08 90.8801 124.98 90.5401 124.52C90.2001 124.06 90.3001 123.41 90.7601 123.08C91.2201 122.74 91.8601 122.84 92.2001 123.3C92.5401 123.76 92.4301 124.41 91.9801 124.74Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62 137.66C112.16 138 111.52 137.9 111.18 137.44C110.84 136.98 110.95 136.34 111.4 136C111.85 135.66 112.5 135.76 112.84 136.22C113.18 136.68 113.08 137.33 112.62 137.66Z",
    fill: "#F5C92B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31 130.98C117.85 131.32 117.21 131.22 116.87 130.76C116.53 130.3 116.64 129.66 117.1 129.32C117.56 128.98 118.2 129.08 118.54 129.54C118.88 130 118.78 130.65 118.32 130.98H118.31Z",
    fill: "#F5C92B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198.9,
    height: 198.9,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerfulReports);
export default __webpack_public_path__ + "static/media/powerfulReports.71bb0146e86aaa5f8dc8277c64bc8863.svg";
export { ForwardRef as ReactComponent };